<template>
  <Head :title="$t('global.settings')" />
  <h1 class="mb-8 text-3xl font-bold">{{$t('global.settings')}}</h1>
  <div class="2xl:w-2/3 w-3/3">
    <div class="grid xl:grid-cols-3 grid-cols-1 gap-10">
      <card-link
        v-for="(item, key) in items"
        v-bind:key="key"
        :title="item.title"
        :text="item.text"
        :button-text="item.buttonText"
        :button-link="item.buttonLink"
      />
    </div>
  </div>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import CardLink from '@/Shared/CardLink'

export default{
  components:{Head, CardLink},
  layout: Layout,
  data(){
    return {
      items: [
        {
          title: this.$t('settings.languages'),
          text: this.$t('settings.languages_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.languages'),
          buttonLink: '/languages',
        },
        {
          title: this.$t('settings.civil_states'),
          text: this.$t('settings.civil_states_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.civil_states'),
          buttonLink: '/civilstates',
        },
        {
          title: this.$t('settings.cooperations'),
          text: this.$t('settings.cooperations_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.cooperations'),
          buttonLink: '/cooperations',
        },
        {
          title: this.$t('settings.locations'),
          text: this.$t('settings.locations_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.locations'),
          buttonLink: '/locations',
        },
        {
          title: this.$t('settings.intervention_types'),
          text: this.$t('settings.intervention_types_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.intervention_types'),
          buttonLink: '/interventiontypes',
        },
        {
          title: this.$t('settings.requests'),
          text: this.$t('settings.requests_info'),
          buttonText: this.$t('global.update') + ' ' + this.$t('settings.requests'),
          buttonLink: '/requests',
        },
      ],
    }
  },
}
</script>
